import { fromApiVolumeUnit, toApiVolumeUnit } from '@/utils/unitConversion';

import type {
  CreateOilLogFormValues,
  CreateOilLogRequestDto,
  OilLog,
  OilLogEntry,
  OilLogEntryDto,
  OilLogResponseDto,
  UpdateOilLogFormValues,
  UpdateOilLogRequestDto,
} from './oil-log.dto';

export const mapOilLogEntry = ({
  date_time,
  bunker_taken_usg,
  total_onboard_usg,
  cost_usd,
  cost_local_currency,
  cost_per_usg_after_tax_usd,
  bunker_taken_units,
  cost_per_units,
  total_onboard_units,
  ...rest
}: OilLogEntryDto): OilLogEntry => ({
  ...rest,
  dateTime: date_time,
  bunkerTakenUsg: bunker_taken_usg,
  totalOnboardUsg: total_onboard_usg,
  costUsd: cost_usd,
  costLocalCurrency: cost_local_currency,
  costPerUsgAfterTaxUsd: cost_per_usg_after_tax_usd,
  bunkerTakenUnit: fromApiVolumeUnit(bunker_taken_units),
  costPerUnit: fromApiVolumeUnit(cost_per_units),
  totalOnboardUnit: fromApiVolumeUnit(total_onboard_units),
});

export const mapOilLogEntryDto = ({
  dateTime,
  bunkerTakenUsg,
  totalOnboardUsg,
  costUsd,
  costLocalCurrency,
  costPerUsgAfterTaxUsd,
  bunkerTakenUnit,
  costPerUnit,
  totalOnboardUnit,
  ...rest
}: OilLogEntry): OilLogEntryDto => ({
  ...rest,
  date_time: dateTime,
  bunker_taken_usg: bunkerTakenUsg,
  total_onboard_usg: totalOnboardUsg,
  cost_usd: costUsd,
  cost_local_currency: costLocalCurrency,
  cost_per_usg_after_tax_usd: costPerUsgAfterTaxUsd,
  bunker_taken_units: toApiVolumeUnit(bunkerTakenUnit),
  cost_per_units: toApiVolumeUnit(costPerUnit),
  total_onboard_units: toApiVolumeUnit(totalOnboardUnit),
});

export const mapOilLog = ({
  vessel_id,
  vessel_name,
  created_at,
  updated_at,
  entries,
  ...rest
}: OilLogResponseDto): OilLog => ({
  ...rest,
  vesselId: vessel_id,
  vesselName: vessel_name,
  createdAt: created_at,
  updatedAt: updated_at,
  entries: (entries ?? []).map(mapOilLogEntry),
});

const toRfc3339 = (date: string): string => {
  const d = new Date(date.length === 10 ? `${date}T00:00:00.000Z` : date);
  return Number.isNaN(d.getTime()) ? date : d.toISOString();
};

export const mapCreateOilLogDto = ({
  date,
  entries,
}: CreateOilLogFormValues): CreateOilLogRequestDto => ({
  date: toRfc3339(date),
  entries: entries?.map(mapOilLogEntryDto),
});

export const mapUpdateOilLogDto = ({
  id,
  entries,
}: UpdateOilLogFormValues): UpdateOilLogRequestDto => ({
  id,
  entries: entries?.map(mapOilLogEntryDto),
});
